@for (wednesday of data().wedns; track wednesday) {
  <tr>
    <td [colSpan]="data().all_screen.length" class="week-header">
      <span class="sticky-header">
        {{ wednesday }}
      </span>
    </td>
  </tr>

  @if (isWeekEmpty(wednesday)) {
    <tr
      app-planning-region-empty-row
      [dateValue]="dateValue()"
      [data]="data()"
      [wednesday]="wednesday">
    </tr>
  } @else {
    @for (index of getMaxProgrammesLength(wednesday); track index) {
      <tr
        app-planning-region-row
        [dateValue]="dateValue()"
        [data]="data()"
        [programmeIndex]="index"
        [wednesday]="wednesday"
        (handleLoadRegionData)="handleLoadRegiondata($event)">
      </tr>
    }
  }
}
